import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { Box } from 'reflexbox';

import * as graphql from '@treams/treams-network';
import { Modal, Paragraph, Popover, Separator, tokens } from '@treams/treams-ui';

import { CycleMomentOptionCard } from './CycleMomentOptionCard';
import CycleMomentSelector from './CycleMomentSelector';

export default function CycleMomentSelectorModal(props: {
	type: graphql.MomentType;
	regularURL: string;
	momentURL: (moment: { id: string }) => string;
	returnURL: string;
}) {
	const { t } = useTranslation();
	const history = useHistory();

	return (
		<Popover visible center>
			<Modal>
				<Modal.Header title={t(`cycle.momentSelector.${props.type.toLowerCase()}.title`)} />
				<Modal.Contents>
					<Box>
						<Paragraph mb={`${tokens.gap.element}px`}>
							{t(`cycle.momentSelector.${props.type.toLowerCase()}.description`)}
						</Paragraph>
						<CycleMomentSelector
							type={props.type}
							onSelect={(moment, automatic) => {
								const url = moment ? props.momentURL(moment) : props.regularURL;
								if (automatic) {
									history.replace(url);
								} else {
									history.push(url);
								}
							}}
						/>
					</Box>
					<Box my={3}>
						<Separator.Inlay>
							<Paragraph>{t('cycle.momentsSelector.or')}</Paragraph>
						</Separator.Inlay>
					</Box>
					<Box>
						<Paragraph mb={`${tokens.gap.element}px`}>
							{t('cycle.momentSelector.alternative.description')}
						</Paragraph>
						<CycleMomentOptionCard
							title={t(`cycle.momentSelector.${props.type.toLowerCase()}.action`)}
							onClick={() => history.push(props.regularURL)}
						/>
					</Box>
				</Modal.Contents>
				<Modal.FormFooter onCancel={() => history.push(props.returnURL)} disabled />
			</Modal>
		</Popover>
	);
}
